export enum RouteKey {
  HOME = '/',
  LOGIN = '/login',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_SUCCESS = '/reset-password-success',
  MARKETPLACE_ONLINEDIENSTE = '/marketplace-onlinedienste',
  MANAGED_ONLINEDIENSTE = '/managed-onlinedienste',
  MANAGED_ONLINEDIENST = '/managed-onlinedienste/:processId',
  TEMPLATE_CONFIGURATION = '/template-configuration',
  CONTACT = '/contact',
  IMPRINT = '/imprint',
  DATA_PROTECTION = '/dataprotection',
  TERMS_OF_USE = '/termsofuse',
  ZUSTAENDIGE_STELLEN = '/zustaendigeStellen',
  HELP = '/help',
  NOT_FOUND = '*'
}
